// ── WebGL capability detection (single source of truth).
// Cached at module scope so we run the probe exactly once per session.
let _cachedSupport = null;

/** Returns true only if the current browser can genuinely render WebGL.
 *  Handles: disabled GPU, headless contexts, iOS "low power" fallback,
 *  and old Androids where `webgl2` fails but plain `webgl` works. */
export function hasWebGL() {
  if (_cachedSupport !== null) return _cachedSupport;
  if (typeof window === "undefined" || typeof document === "undefined") {
    _cachedSupport = false;
    return _cachedSupport;
  }
  try {
    const c = document.createElement("canvas");
    // Try webgl2 first, fall back to webgl and experimental-webgl.
    const gl = c.getContext("webgl2") || c.getContext("webgl") || c.getContext("experimental-webgl");
    _cachedSupport = Boolean(gl && gl.getParameter);
  } catch {
    _cachedSupport = false;
  }
  return _cachedSupport;
}

/** Reset cache — testing only. */
export function _resetWebGLCache() {
  _cachedSupport = null;
}
